import { render, staticRenderFns } from "./pointViewDesign.vue?vue&type=template&id=52215dc5&scoped=true&"
import script from "./pointViewDesign.vue?vue&type=script&lang=js&"
export * from "./pointViewDesign.vue?vue&type=script&lang=js&"
import style0 from "./pointViewDesign.vue?vue&type=style&index=0&id=52215dc5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52215dc5",
  null
  
)

export default component.exports